import resetOn from './resetOn'
import { swapEdit, normalizeCollection } from './helpers'
import {
  GET_NEW_SWAP_DATA_LOADING,
  GET_NEW_SWAP_DATA_SUCCESS,
  GET_NEW_SWAP_DATA_FAILURE,
  GET_NEW_SWAP_DATA_UNLOAD,
  CREATE_NEW_SWAP_LOADING,
  CREATE_NEW_SWAP_SUCCESS,
  CREATE_NEW_SWAP_FAILURE,
} from '../actions'

const swapSkeleton = {
  proponente: null,
  destinatario: null,
  proponenteItems: {
    data: {},
    ids: [],
  },
  destinatarioItems: {
    data: {},
    ids: [],
  },
  proponenteMoney: 0,
  destinatarioMoney: 0,
}

const defaultState = {
  loading: false,
  error: null,
  swap: null,
  creating: false,
  createError: null,
}

const reducer = (prevState = defaultState, action) => {
  const { type, payload, error } = action

  switch (type) {
    case GET_NEW_SWAP_DATA_LOADING:
      return {
        ...prevState,
        loading: true,
      }
    case GET_NEW_SWAP_DATA_SUCCESS:
      return {
        ...prevState,
        loading: true,
        swap: {
          ...swapSkeleton,
          ...payload,
          destinatarioItems: normalizeCollection(payload.destinatarioItems),
          proponenteItems: normalizeCollection(payload.proponenteItems),
        },
      }
    case GET_NEW_SWAP_DATA_FAILURE:
      return {
        ...prevState,
        loading: false,
        error,
      }
    case CREATE_NEW_SWAP_LOADING:
      return {
        ...prevState,
        creating: true,
        createError: null,
      }
    case CREATE_NEW_SWAP_SUCCESS:
      return {
        ...prevState,
        creating: false,
        swap: {
          ...prevState.swap,
          id: payload.id, // <-- Little trick to notify UI when swap has been created
        },
      }
    case CREATE_NEW_SWAP_FAILURE:
      return {
        ...prevState,
        creating: false,
        createError: error,
      }
    default:
      return prevState
  }
}

export default resetOn(GET_NEW_SWAP_DATA_UNLOAD, swapEdit('NEW_SWAP', reducer))



// WEBPACK FOOTER //
// ./src/reducers/newSwap.js